import lazy from 'preact-lazy';
import { useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { noopFunction } from '@vestico/utils';

import { MatchButtonGlobalsContext } from '../../WidgetEventsManager';

const ToBeLazyLoaded = lazy(() => import('./MatchModal'), null);

let immortals = 0;

export const MatchModalLazyLoader = () => {
  const [isSingleton, setIsSingleton] = useState(false);
  const { matchButtonOpen } = useContext(MatchButtonGlobalsContext);
  const [showPortal, setShowPortal] = useState(matchButtonOpen);

  useEffect(() => {
    if (!matchButtonOpen) {
      const timeout = setTimeout(() => setShowPortal(false), 1000);
      return () => clearTimeout(timeout);
    }
    setShowPortal(true);
    return noopFunction;
  }, [matchButtonOpen]);

  useEffect(() => {
    immortals++;

    if (immortals === 1) {
      setIsSingleton(true);
    }

    return () => {
      immortals--;
    };
  }, []);

  return isSingleton && showPortal ? createPortal(<ToBeLazyLoaded />, document.body) : <></>;
};
